// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1Vr_q","label":"SetPasswdForm_label__frP-g"};